export default __webpack_public_path__ + "images/6d5017f4221b8f0608b890f7df4bb754.svg";